import styled from 'styled-components';

export const AppNavigationWrapper = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;
AppNavigationWrapper.displayName = 'AppNavigationWrapper';
